import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getConfig } from 'src/configs'
import isbot from 'isbot'
import { Platform } from 'quasar'
import { RESTRICTION } from 'src/common/dictionary'

const releaseFromRequire = require('src/release')
const config = getConfig()
export const useSystemStore = defineStore('system', () => {
  const prevRoute = ref(null)
  const lang = ref('en')
  const underdev = ref(true)
  const userDialog = ref({ show: false, type: '', message: '' })
  const release = ref(releaseFromRequire?.version)
  const countOfErrorsChunkLoaded = ref(0)
  const isBot = ref(isbot(navigator.userAgent))
  const main = ref(config.code === 'b6e48fe2')
  const alt = ref(config.code === 'r7cb4846')
  const restricted = ref(RESTRICTION.NOT_READY)

  const isMobile = computed(() => {
    if (Platform.is.mobile) {
      return true
    }
    return Platform.is.desktop ? false : Platform.is.ios || Platform.is.android || Platform.is.ipad
  })
  const getPlatformName = computed(() => {
    if (main.value) {
      return 'main'
    }

    if (alt.value) {
      return 'alt'
    }

    return ''
  })

  function updateErrorChunks() {
    countOfErrorsChunkLoaded.value++
  }
  function updatePrevRoute(payload) {
    prevRoute.value = payload
  }
  function updateUnderDev(payload) {
    underdev.value = payload
  }
  function updateRestricted(payload) {
    restricted.value = payload
  }

  return {
    // refs
    prevRoute,
    underdev,
    userDialog,
    release,
    countOfErrorsChunkLoaded,
    isBot,
    main,
    lang,
    alt,
    restricted,
    // computed
    isMobile,
    getPlatformName,
    //functions
    updateErrorChunks,
    updatePrevRoute,
    updateUnderDev,
    updateRestricted,
  }
})
